import { Tag } from '@cian/components';
import * as React from 'react';

import { IGeoCircleTag } from '../../../../../state/tags/definitions/geo';
import { TagNew } from '../../../TagNew';

import { tagThemeSmall } from '../../../tag_theme';

export interface IGeoCircleTagItemProps {
  tag: IGeoCircleTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const GeoCircleTagItem = (props: IGeoCircleTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {props.tag.text}
    </TagComponent>
  );
};
